export default __webpack_public_path__ + "static/media/stanfordLogo.43b69d60.png";